import axios from 'axios';
import {Config} from "../cfg/Config";
import DateTimeUtil from "../common/DateTimeUtil";
import {errorUtils} from "./errorUtils";

const qs = require('qs');

class OvertimeService {
    request(user_id: number, email: string, date: string, month: number, year: number, ot_hour: number,  reason: string) {
        return axios
            .post(Config.API_URL + "overtime.php", qs.stringify({
                action: "request",
                user_id: user_id,
                email: email,
                date: date,
                month: month,
                year: year,
                ot_hour: ot_hour,
                reason: reason,
            }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            })
            .then(response => {
                // console.log(response.data);
                return response.data;
            });
    }

    approve(id: number, approver: string | undefined, approve: number) {
        return axios
            .post(Config.API_URL + "overtime.php", qs.stringify({
                action: "approve",
                id: id,
                approve: approve,
                approver: approver,
            }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            })
            .then(response => {
                // console.log(response.data);
                return response.data;
            });
    }

    update(email: string, id: number, date: string, month: number, year: number, ot_hour: number, reason: string) {
        return axios
            .post(Config.API_URL + "overtime.php", qs.stringify({
                action: "update",
                id: id,
                email: email,
                date: date,
                month: month,
                year: year,
                ot_hour: ot_hour,
                reason: reason,
            }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            })
            .then(response => {
                // console.log(response.data);
                return response.data;
            });
    }

    delete(id: number) {
        return axios
            .post(Config.API_URL + "overtime.php", qs.stringify({
                action: "delete",
                id: id,
            }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            })
            .then(response => {
                // console.log(response.data);
                return response.data;
            });
    }

    getOvertimeRequests(email: string, month: number, year: number) {
        let fromDate = new Date(year, month - 1, 26);
        let toDate = new Date(year, month, 25);
        return axios
            .post(Config.API_URL + "overtime.php", qs.stringify({
                action: "multi_range",
                email: email,
                from_day: 26,
                from_month: ("0" + DateTimeUtil.getMonth(fromDate.getMonth(), fromDate.getFullYear())).slice(-2),
                from_year: DateTimeUtil.getYear(fromDate.getMonth(), fromDate.getFullYear()),
                to_day: 25,
                to_month: ("0" + DateTimeUtil.getMonth(toDate.getMonth(), toDate.getFullYear())).slice(-2),
                to_year: DateTimeUtil.getYear(toDate.getMonth(), toDate.getFullYear())
            }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            })
            .then(response => {
                // console.log(response.data);
                return response.data;
            }).catch(error => {
                console.error(errorUtils.getError(error));
            });
    }

    getAllOvertimeRequestsByDay(day: number, month: number, year: number) {
        /*let fromDate = new Date(year, month, day);
        let toDate = new Date(year, month, day);*/
        return axios
            .post(Config.API_URL + "overtime.php", qs.stringify({
                action: "all_range",
                from_day: day < 10 ? "0" + day : day,
                from_month: month < 10 ? "0" + month : month,
                from_year: year,
                to_day: day < 10 ? "0" + day : day,
                to_month: month < 10 ? "0" + month : month,
                to_year: year
            }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            })
            .then(response => {
                // console.log(response.data);
                return response.data;
            });
    }

    getAllOvertimeRequests(month: number, year: number) {
        let fromDate = new Date(year, month - 1, 26);
        let toDate = new Date(year, month, 25);
        return axios
            .post(Config.API_URL + "overtime.php", qs.stringify({
                action: "all_range",
                from_day: 26,
                from_month: ("0" + DateTimeUtil.getMonth(fromDate.getMonth(), fromDate.getFullYear())).slice(-2),
                from_year: DateTimeUtil.getYear(fromDate.getMonth(), fromDate.getFullYear()),
                to_day: 25,
                to_month: ("0" + DateTimeUtil.getMonth(toDate.getMonth(), toDate.getFullYear())).slice(-2),
                to_year: DateTimeUtil.getYear(toDate.getMonth(), toDate.getFullYear())
            }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            })
            .then(response => {
                // console.log(response.data);
                return response.data;
            });
    }
}

export default new OvertimeService();